import { useState } from 'react'

import { Heading, theme } from '@hhgtech/hhg-components'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { List, Stack, StackProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import { assetImagePath } from 'interfaces/constants'
import { useExpertStore } from 'state/expert'

type _ExperienceProps = StackProps
export const _Experience = ({ ...rest }: _ExperienceProps) => {
  const [showAllExperiences, setShowAllExperiences] = useState(true)
  const { currentExpert: expert } = useExpertStore((state) => ({
    currentExpert: state.currentExpert,
  }))
  const { formatMessage: f } = useIntl()
  return (
    <>
      {expert?.fields?.experiences &&
        Array.isArray(expert?.fields?.experiences) &&
        expert?.fields?.experiences.length > 0 && (
          <Stack spacing={16} {...rest}>
            <Text weight="bold" size="c2" color={theme.colors.gray400}>
              {f({
                id: 'expert.content.experiences',
                defaultMessage: 'Experiences',
              }).toUpperCase()}
            </Text>

            <List
              styles={{
                itemIcon: {
                  marginRight: 0,
                },
              }}
              spacing={12}
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="2" fill="#2D87F3" />
                </svg>
              }
            >
              {(showAllExperiences
                ? expert?.fields?.experiences
                : expert?.fields?.experiences.slice(0, 3)
              ).map((experience, index) => (
                <List.Item key={`item-${index}`}>
                  <Stack spacing={0}>
                    <Heading tag="h6" color={theme.colors.gray800}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: experience?.title || '',
                        }}
                      />
                    </Heading>
                    <Text size="p3" color={theme.colors.gray500}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: experience?.organization || '',
                        }}
                      ></span>
                    </Text>
                  </Stack>
                </List.Item>
              ))}
            </List>

            {expert?.fields?.experiences.length > 3 && !showAllExperiences && (
              <Button
                variant="ghost"
                compact
                size="sm"
                w="fit-content"
                rightIcon={
                  <img
                    src={`${assetImagePath}/chevronDownBlue.svg`}
                    alt="see-more"
                    loading="lazy"
                  />
                }
                onClick={() => setShowAllExperiences(true)}
              >
                {f({
                  id: 'expert.content.seeMore',
                  defaultMessage: 'See more',
                })}
              </Button>
            )}
          </Stack>
        )}
    </>
  )
}
